import { render, staticRenderFns } from "./von-buhl.vue?vue&type=template&id=e6e7834c&scoped=true"
import script from "./von-buhl.vue?vue&type=script&lang=js"
export * from "./von-buhl.vue?vue&type=script&lang=js"
import style0 from "./von-buhl.vue?vue&type=style&index=0&id=e6e7834c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e7834c",
  null
  
)

export default component.exports